class quiz extends HTMLElement{
    constructor(){
        super();
        this.openQuizbtn=this.querySelector('[data-openquiz]');
        this.startQuizbtn=this.querySelector('.start-quiz');
        this.ClosemainQuiz=this.querySelector('.close-main-quiz');
        this.selectContainer = this.querySelector('.quiz-drawer');
        this.QuizContainer = this.querySelector('.quiz-drawer-main');
        this.QuizAnswerContainer = this.querySelector('.quiz-drawer-result');
        this.backButton = this.querySelectorAll('[data-back]');
        this.lastCloseBtn = this.querySelector('[data-close-last-screen]');
        this.findScent = this.querySelector('.find-your-scent');
        this.yesResult = this.querySelector('[data-result-yes]');
        this.noResult = this.querySelector('[data-result-no]');
        this.backResult = this.querySelector('[data-back-result]');
        
        this.overlay=this.querySelector('.iwt__content--wrapper');
        this.BackBtn=this.querySelector('.back-button');
        this.closeQuiz=this.querySelector('.close-quiz');

        if(this.openQuizbtn){
            this.openQuizbtn.addEventListener('click', () => {
                this.manageVisibilityQuizMain(this.selectContainer,this.overlay,'overlay');
            });
        }
        
        window.dataLayer = window.dataLayer || [];

        this.startQuizbtn.addEventListener('click', () => {
            this.manageVisibilityQuizMain(this.selectContainer,this.QuizContainer);
            window.dataLayer.push({
            'event': 'quiz-start'
            });
        });
        this.ClosemainQuiz.addEventListener('click', () => {
            this.manageVisibilityQuizMain(this.selectContainer,this.QuizContainer);
        });
        this.closeQuiz.addEventListener('click', () => {
            this.manageVisibilityQuizMain(this.selectContainer,this.overlay,'overlay');  
        });

        this.lastCloseBtn.addEventListener('click', () => {
            this.resetQuiz();  
        })

        this.noResult.addEventListener('click', () => {
            this.resultNo();
        });
        this.backResult.addEventListener('click', () => {
            this.finalresultBack();
        });
        let backbtns = this.backButton;
        backbtns.forEach(btn => {
            btn.addEventListener('click',(e) => {
                this.getBack(e);
            }); 
        })
        
        this.countQuestions = this.querySelectorAll('.question-parent').length
        for(let i = 1; i <= this.countQuestions; i++){
            this["question_"+i] = [];
            let radios = this.querySelectorAll('[name="radioQue_'+ i +'"]');
            radios.forEach( radio => {
                radio.addEventListener('change', this.answerSelection.bind(this)); 
            })   
        }

        this.yesResult.addEventListener('click', () => {
            this.manageVisibilityQuizMain(this.QuizAnswerContainer,this.QuizContainer)
            this.getFinalResult();
        })
    }

    /**
     * Called when back button click on Final result slide
     */
    finalresultBack(){
        this.querySelector('[data-confirmPopup]').classList.add('d-none');
        this.countQuestions = this.querySelectorAll('.question-parent').length;
        this.querySelector('[data-question="'+this.countQuestions+'"] [data-answerindex="'+this.countQuestions+'"]').classList.add('d-none');
        this.querySelector('[data-question="'+this.countQuestions+'"] [data-answerindex="'+this.countQuestions+'"]').innerHTML = '';
        this.querySelector('[data-answerlistindex="'+this.countQuestions+'"]').classList.remove('d-none');
        this["question_"+this.countQuestions] = [];
        // $('.footer-quiz input[name="radioQue_'+this.countQuestions+'"]:radio:checked').prop('checked', false);
        const radioInput = document.querySelector('.footer-quiz input[name="radioQue_' + this.countQuestions + '"]:checked');
        if (radioInput) {
        radioInput.checked = false;
        }
        
        this.manageVisibilityQuizMain(this.QuizContainer,this.QuizAnswerContainer);
        this.finalProducts = this.querySelectorAll('[data-fragrance_hierarchy] [data-product-handle]');
        this.finalProducts.forEach(finalProduct => {
            finalProduct.classList.add('d-none');
        });
    } 

    /**
     * When click on no, this function will be called
     */
    resultNo(){
        this.querySelector('[data-confirmPopup]').classList.add('d-none');
        this.countQuestions = this.querySelectorAll('.question-parent').length;
        this.querySelector('[data-question="'+this.countQuestions+'"] [data-answerindex="'+this.countQuestions+'"]').classList.add('d-none');
        this.querySelector('[data-question="'+this.countQuestions+'"] [data-answerindex="'+this.countQuestions+'"]').innerHTML = '';
        this.querySelector('[data-answerlistindex="'+this.countQuestions+'"]').classList.remove('d-none');
        // $('.footer-quiz input[name="radioQue_'+this.countQuestions+'"]:radio:checked').prop('checked', false);
        const radioInput = document.querySelector('.footer-quiz input[name="radioQue_' + this.countQuestions + '"]:checked');
        if (radioInput) {
        radioInput.checked = false;
        }
        this["question_"+this.countQuestions] = [];
    }

    /**
     * Reset quiz
     */
    resetQuiz(){

        this.manageVisibilityQuizMain(this.QuizAnswerContainer, this.selectContainer);
        this.questionParents = this.querySelectorAll('.question-parent');
        this.questionParents.forEach((questionParent,index) => {
            if(index != 0){
                questionParent.classList.add('d-none');
            }
        });
        this.finalAnswers = this.querySelectorAll('[data-answerindex]');
        this.finalAnswers.forEach(finalAnswer => {
            finalAnswer.classList.add('d-none');
            finalAnswer.innerHTML = '';
        })
        this.answerLists = this.querySelectorAll('[data-answerlistindex]');
        this.answerLists.forEach((answerList,index) => {
            if(index == 0){
                answerList.classList.remove('d-none');
            }else{
                answerList.classList.add('d-none');
            }
        });

        this.querySelector('[data-back]').setAttribute('data-back-index',"0");
        this.querySelector('[data-currentquestion]').innerHTML = "1";
        this.finalProducts = this.querySelectorAll('[data-fragrance_hierarchy] [data-product-handle]');
        this.finalProducts.forEach(finalProduct => {
            finalProduct.classList.add('d-none');
        });
        this.countQuestions = this.querySelectorAll('.question-parent').length
        for(let i = 1; i <= this.countQuestions; i++){
            this["question_"+i] = [];
        }
        this.overlay.classList.remove('open');
        // $('.footer-quiz input:radio:checked').prop('checked', false);
        const checkedRadioInputs = document.querySelectorAll('.footer-quiz input[type="radio"]:checked');
        checkedRadioInputs.forEach(input => {
        input.checked = false;
        });
        this.querySelector('[data-confirmPopup]').classList.add('d-none');
        
    }

    /**
     * For manage visibility for slides
     * @param {*} showContainer : show container selector
     * @param {*} hideContainer : hide container selector
     * @param {*} type : Set for overlay setting
     */
    manageVisibilityQuizMain(showContainer,hideContainer,type){
        let isOpen = showContainer.classList.contains('open');
        isOpen ? showContainer.classList.remove('open') : showContainer.classList.add('open');
        let isOpenquiz = showContainer.classList.contains('open');
        isOpenquiz ? hideContainer.classList.remove('open') : hideContainer.classList.add('open');
        
        if(type == 'overlay'){
            let isOpenOverlay = this.overlay.classList.contains('open');
            isOpenOverlay ? this.overlay.classList.remove('open') : this.overlay.classList.add('open');
        }
        
        if(isOpenquiz){
            window.scrollTo(0, 0);
        }
    }

    /**
     * Called when back button click of question answer slide
     * @param {*} e : click event
     */
    getBack(e){ 
        if(e.currentTarget.getAttribute('data-back-index') == '0'){
            console.log('o index')
            this.manageVisibilityQuizMain(this.selectContainer,this.QuizContainer);
        }else{
            let showIndex = parseInt(e.currentTarget.getAttribute('data-back-index'));
            let hideIndex = showIndex + 1;
            this.showQuestionAnswer(showIndex,hideIndex);
            this["question_"+hideIndex] = [];
            let thisRadios = this.querySelectorAll('[name="radioQue_'+showIndex+'"]');
            // $('input:radio[name="radioQue_'+showIndex+'"]:checked').prop('checked', false);
            const specificRadioInput = document.querySelector('input[name="radioQue_' + showIndex + '"]:checked');
            if (specificRadioInput) {
            specificRadioInput.checked = false;
            }
            e.currentTarget.setAttribute('data-back-index',(showIndex - 1))
            
        }
    }

    
    /**
     * Show Hide question answer based on selection
     * @param {*} showIndex : Index to show question and answer
     * @param {*} hideIndex : Index to hide question and answer
     */
    showQuestionAnswer(showIndex,hideIndex){
        console.log('showIndex', showIndex);
        console.log('hideIndex', hideIndex);
        this.querySelector('[data-answerindex="'+showIndex+'"]').innerHTML = '';
        this.querySelector('[data-answerindex="'+showIndex+'"]').classList.add('d-none');
        this.querySelector('[data-answerlistindex="'+showIndex+'"]').classList.remove('d-none');
        this.querySelector('[data-answerlistindex="'+hideIndex+'"]').classList.add('d-none');
        this.querySelector('[data-question="'+hideIndex+'"]').classList.add('d-none');
        this.querySelector('[data-currentquestion]').innerHTML = showIndex
    }

    /**
     * Prepare final result array
     */
    getFinalResult(){
        let commonArray = []
        let commonLastArray = [];
        var lastCount = this.countQuestions;
        for(let i = 1; i <= this.countQuestions; i++){
            this["question_"+i].forEach(ele => {
                if(i == lastCount){
                    commonLastArray.push(ele);
                }else{
                    commonArray.push(ele);
                }
            });
        }
        
        var holder = {};
        commonArray.forEach(function(d) {
            if (holder.hasOwnProperty(d.product)) {
                holder[d.product] = holder[d.product] + parseInt(d.point);
            } else {
                holder[d.product] = parseInt(d.point);
            }
        });
       
        var commonArraya = [];
        for (var prop in holder) {
            commonArraya.push({ product: prop, point: holder[prop] });
        }

        let firstArray = commonArraya;
        let secondArray = commonLastArray;

        var resultM = firstArray.filter(function (o1) {
            return secondArray.some(function (o2) {
                return o1.product === o2.product; // return the ones with equal id
           });
        });
        let t= Math.max.apply(Math, resultM.map(function(o) { return o.point; }))
            var result = resultM.filter(obj => {
            return obj.point === t
        })

        if(result.length == 0){
            const rndInt = this.randomIntFromInterval(0, (parseInt(commonLastArray.length) - 1))
            this.querySelectorAll('[data-fragrance_hierarchy] [data-product-handle]').forEach(ele =>{
                if(commonLastArray[rndInt].product == ele.getAttribute('data-product-handle') && ele.getAttribute('data-available') == "true"){
                    ele.classList.remove('d-none');
                    let productTitle = ele.getAttribute('data-product-title');
                    
                    window.dataLayer.push({
                        'event': 'quiz-result-product',
                        'product_title': productTitle
                    });
                }
            });
        }else{
            this.checkForhierarchy(result);
        }
    }

    /**
     * Based on result array check for assigned hierarchy
     * @param {*} result : Result array
     */
    checkForhierarchy(result){
        let checkFirst = false;
        this.querySelectorAll('[data-fragrance_hierarchy] [data-product-handle]').forEach(ele =>{
            if(checkFirst == false){
                result.forEach(r => {
                    if(r.product == ele.getAttribute('data-product-handle') && ele.getAttribute('data-available') == "true"){
                        ele.classList.remove('d-none');
                        let productTitle = ele.getAttribute('data-product-title');
                        window.dataLayer.push({
                            'event': 'quiz-result-product',
                            'product_title': productTitle
                        });
                        checkFirst = true;
                        return false;
                    }
                })
            }
        });
    }

    
    randomIntFromInterval(min, max) { // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    /**
     * Based on selected answer get result
     */
    answerSelection(event){
        
        let name = event.target.getAttribute('name');
        let nameSplit = name.split('_')[1];
        let targetedElse = this.querySelectorAll('[name="'+ name +'"]');
        let selectedEle = '';
        let point = '';
        let selectedAnswer = '';
        
        targetedElse.forEach(targetedEle => {
            if (targetedEle.checked) {
                selectedEle = targetedEle.getAttribute('data-associate-product');
                point = targetedEle.getAttribute('data-point');
                selectedAnswer = targetedEle.value;
            }
        });
        let array = [];
        selectedEle = selectedEle.split(',');
        selectedEle.forEach(product => {
            if(product != ''){
                array.push({
                    product,
                    point
                })
            }
        })
        this['question_'+nameSplit] = array;
        let countQuestions = this.countQuestions

       
            document.querySelector('[data-answerindex="'+nameSplit+'"]').innerHTML = selectedAnswer;
            document.querySelector('[data-answerindex="'+nameSplit+'"]').classList.remove('d-none');
            document.querySelector('[data-answerlistindex="'+nameSplit+'"]').classList.add('d-none');
    
            let step = 'step-'+nameSplit;
            let question = document.querySelector('[data-question="'+ (parseInt(nameSplit)) +'"] .question p').innerHTML;
            let answer = document.querySelector('[data-answerindex="'+ (parseInt(nameSplit)) +'"]').innerHTML;

            let questionType = 'question_'+nameSplit;
            let answerType = 'answer_'+nameSplit;
            window.dataLayer.push({
                'event': step,
                [questionType] : question,
                [answerType] : answer
            });
        setTimeout(function(){ 
            
            if(countQuestions != nameSplit){
                document.querySelector('[data-currentQuestion]').innerHTML = parseInt(nameSplit)+1;
                document.querySelector('[data-question="'+ (parseInt(nameSplit)+1) +'"]').classList.remove('d-none');
                document.querySelector('[data-answerlistindex="'+(parseInt(nameSplit)+1)+'"]').classList.remove('d-none');
    
                document.querySelector('[data-back-index]').setAttribute('data-back-index',nameSplit);
                var objDiv = document.querySelector(".main-quiz-body");
                objDiv.scrollTop = objDiv.scrollHeight;

                
            }else{
                document.querySelector('[data-confirmPopup]').classList.remove('d-none');
            }
        },800)
    }
}
customElements.define("custom-quiz", quiz); 